import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsSchedulingGroupsFieldConfig } from '../shared/models/generated/ziroModels';

export class TeamsCallQueueSchedulingGroupsResource {
  private _httpClient = inject(HttpClient);

  get(tenantId: string, teamId: string): Observable<MicrosoftTeamsSchedulingGroupsFieldConfig> {
    return this._httpClient.get<MicrosoftTeamsSchedulingGroupsFieldConfig>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/scheduling-groups?teamId=${encodeURIComponent(teamId)}`,
    );
  }
}
